let activeGuard = null;
let installed = false;
const popstate = (event) => activeGuard?.(event);

/** Install before BrowserRouter: Window target listeners follow registration order. */
export function installKnowledgeNavigationBoundary() {
  if (installed) return;
  window.addEventListener('popstate', popstate, true);
  installed = true;
}

export function registerKnowledgePopstateGuard(guard) {
  activeGuard = guard;
  return () => { if (activeGuard === guard) activeGuard = null; };
}

if (module.hot) module.hot.dispose(() => {
  window.removeEventListener('popstate', popstate, true);
  installed = false;
  activeGuard = null;
});
